import { mapGetters } from 'vuex';
import semver from 'semver'

export default {
    computed: {
        ...mapGetters(["appVersion"]),
    },
    methods: {
        setNextVersion(payload) {
            console.log(payload);
            var isNex = false;
            let nextVersion = payload
            isNex = semver.satisfies(this.appVersion, nextVersion)
            return isNex
        },
    }
}
